import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';

import {
    Button,
    Card,
    Title,
    TextInput,
} from '@tremor/react';

import { validarCNPJ } from '../../utils/validaCnpj';

export default function PartnerRegisterPage() {
    const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;

    let { transporter_org_id } = useParams();

    const [cnpj, setCnpj] = useState<string>('');
    
    const handleRedirect = () => { 
        if(!validarCNPJ(cnpj)) {
            alert("CNPJ inválido")
            return;
        }
        const cleanCnpj = cnpj.replace(/\D/g, '');
        console.log(cleanCnpj);
        window.location.href = `${baseURL}/shopee/partner_link?cnpj=${cleanCnpj}&transporter_org_id=${transporter_org_id}`;
    }

    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
            <Card className="flex justify-center md:mx-[20vw] mx-4">
                <div>
                    <h1 className="text-2xl text-center font-bold mb-4">Cadastro Parceiro</h1>
                    <div className='flex items-center gap-4 mb-8'>
                        <img src={require("../../images/ml2.png")} alt="Mazelog" className='h-28 w-30 '/>
                        <h1 className="text-3xl font-bold">+</h1>
                        <img src={require("../../images/logo-shopee.png")} alt="Shopee" className='h-28 w-24 '/>
                    </div>
                    <p className="text-gray-700">Insira seu CNPJ para iniciar o cadastro</p>
                    <TextInput onChange={(e) => setCnpj(e.target.value)} placeholder='CNPJ' className='max-w-md'/>
                    <Button className='mt-4 FilterButton' onClick={handleRedirect}>Cadastrar</Button>
                </div>
            </Card>
        </div>
    );
}